import React from 'react';

import { Anchor, Stack, Text } from '@mantine/core';

import formatDate from '@/utils/formatDate';
import { getMrnLabel } from '@/utils/getMrnLabel';
import { routes } from '@/routes';

import { PatientData } from '@/types/patientList';

import styles from './cellsV2.module.scss';

interface PatientCellProps {
  patient: PatientData;
}

export const PatientCell: React.FC<PatientCellProps> = ({ patient }) => (
  <Stack gap={1}>
    <Anchor
      component="button"
      className={styles.primaryLink}
      fz={14}
      onClick={() => {
        if (patient.id) {
          window.open(routes.physician.patientDetail(patient.id), '_blank', 'noopener,noreferrer');
        }
      }}>
      {patient.name?.trim() || '—'}
    </Anchor>
    <Text className={styles.sub} fz={12}>
      {formatDate(patient.dob, 'MM-DD-YYYY')} · {getMrnLabel(patient.useMpiLabel)}{' '}
      {patient.mrn ? patient.mrn.replace(/^MRN[-\s]*/i, '') : 'N/A'}
    </Text>
  </Stack>
);
